module.exports = __webpack_public_path__ + "static/media/ic-checkmark.9dc05227.svg";